import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import request from '../api';
import { miloAlert } from '../AlertDialog';
import { bindArea } from '../AreaBind/areabind';
import { selectRole } from '../RoleSelector/roleselector';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile';
import { getGift as _getGift } from '@tencent/milo-core';

var LotteryComp = /*#__PURE__*/function () {
  function LotteryComp(option) {
    _classCallCheck(this, LotteryComp);

    this.option = _objectSpread({
      plat: 'pc',
      iActivityId: '',
      iFlowId: '',
      withAreaInfo: false,
      flowConfig: {
        sData: {}
      },
      extendRole: {},
      onSuccess: null,
      onFail: null
    }, option);
  }

  _createClass(LotteryComp, [{
    key: "getGift",
    value: function getGift() {
      var self = this;
      var _self$option = self.option,
          onSuccess = _self$option.onSuccess,
          onFail = _self$option.onFail,
          withAreaInfo = _self$option.withAreaInfo,
          plat = _self$option.plat;
      request(_getGift, self.option).then(function (callbackObj) {
        if (!withAreaInfo) {
          if (self.option.flowConfig && self.option.flowConfig.sData) {
            self.option.flowConfig.sData.sRoleId = '';
          }
        }

        if (onSuccess) {
          onSuccess(callbackObj);
          return;
        }

        var packageArr = callbackObj.iPackageId ? callbackObj.iPackageId.split(',') : '';

        if (packageArr && packageArr.length > 1) {
          miloAlert(callbackObj.sMsg);
          return;
        }
        /*
              * 0：虚拟游戏物品
              * 1：实际物品，需要填写个人收货信息
              * 2：cdkey
              */
        // 1：实物


        if (callbackObj.sPackageOtherInfo && callbackObj.sPackageOtherInfo == 'RealGood' || callbackObj.sPackageRealFlag == 1) {
          miloAlert({
            title: '消息提示',
            message: "\u606D\u559C\u60A8\u83B7\u5F97\u4E86".concat(callbackObj.sPackageName, "! \u8BF7\u60A8\u51C6\u786E\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5B98\u65B9\u5C06\u6709\u5DE5\u4F5C\u4EBA\u5458\u8054\u7CFB\u60A8\u3002")
          });
          return;
        } // 2：cdkey


        if (callbackObj.sPackageOtherInfo || callbackObj.sPackageCDkey) {
          // 新的处理
          if (callbackObj.sPackageCDkey) {
            // alert('您获得的cdkey为：' + callbackObj.sPackageCDkey +
            // '<input type="button" value="复制" onclick="ExplorerManager.clipDataToBoard
            // (\''+callbackObj.sPackageCDkey+'\'); alert(\'复制成功。\');">');
            return;
          } // alert('您获得的cdkey为：' + callbackObj.sPackageOtherInfo + '<input type="button" value="复制"
          // onclick="ExplorerManager.clipDataToBoard(\''+callbackObj.sPackageOtherInfo+'\'); alert(\'复制成功。\');">');


          return;
        }

        miloAlert(callbackObj.sMsg);
      })["catch"](function (err) {
        if (err.errCode === 2) {
          // 需要角色，从绑定大区获取
          bindArea({
            plat: plat,
            bindOptions: _objectSpread(_objectSpread({}, err.areaBindOption), {}, {
              flowConfig: _objectSpread({}, self.option.extendRole),
              onSuccess: function onSuccess() {
                self.getGift();
              }
            })
          });
        } else if (err.errCode === 3) {
          // 需要角色，从角色选择器获取
          var selectRoleFn = plat === 'mobile' ? selectRoleMobile : selectRole;

          var rsOption = _objectSpread(_objectSpread(_objectSpread({}, err.rsOption), self.option.extendRole), {}, {
            onSubmit: function onSubmit(role) {
              var sData = self.option.flowConfig.sData || {};
              sData = _objectSpread(_objectSpread({}, sData), {}, {
                sServiceType: err.rsOption.gameId,
                sArea: role.area,
                sPartition: role.partition,
                sRoleId: role.roleId,
                sAreaName: role.areaName,
                sRoleName: role.roleName,
                md5str: role.md5str,
                iSex: role.roleSex || '',
                sPlatId: role.platid,
                ams_checkparam: role.checkparam,
                checkparam: role.checkparam
              });
              self.option.flowConfig.sData = sData;
              self.getGift();
            }
          });

          selectRoleFn(rsOption);
        } else if (err.errCode == -1) {
          if (!withAreaInfo) {
            self.option.flowConfig.sData.sRoleId = '';
          }
        } else {
          if (!withAreaInfo) {
            self.option.flowConfig.sData.sRoleId = '';
          }

          if (onFail) {
            onFail(err);
          } else {
            var errMsg = err.errMsg || err.msg || err.sMsg;
            miloAlert(errMsg);
          }
        }
      });
    }
  }]);

  return LotteryComp;
}();

export { LotteryComp as default };
export var Lottery = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new LotteryComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '抽奖模块初始化失败'
        });
      }
    });
  }
};